<template>
  <form
    class="login"
    @submit.prevent="onLogin"
    v-if="!isLoading"
  >
    <Box class="login__form">
      {{ nextUrl }}
      <transition
        name="jens"
        mode="out-in"
      >
        <div
          v-if="!loading"
          key="sh"
          class="login__form-inner"
        >
          <BaseFormField label="E-mail">
            <BaseInput v-model="form.username" />
          </BaseFormField>
          <BaseFormField label="Kodeord">
            <BaseInput
              type="password"
              v-model="form.password"
            />
          </BaseFormField>
          <BaseButton
            label="Log på"
            full
          />
        </div>
        <div
          class="login__loader login__form-inner"
          v-if="loading"
        >
          <BaseSpinner
            width="100"
            height="100"

            key="je"
          />
        </div>
      </transition>
      <!--  -->
    </Box>

    <svg
      class="login__checkmark"
      width="809px"
      height="971px"
      viewBox="0 0 809 971"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="UI"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Splash"
          transform="translate(-221.000000, -34.000000)"
        >
          <g
            id="Group"
            transform="translate(17.000000, 34.000000)"
          >
            <path
              d="M411.407458,603.702889 L983.718947,6.01031637 C992.591993,-0.66781293 1000.35591,
              -1.78083448 1007.01069,2.67125172 C1013.66548,7.12333792 1014.77461,13.8014672
              1010.33809,22.7056396 L431.371812,960.982806 C426.935289,967.660935 421.389635,971
               414.734851,971 C404.752673,971 398.097889,960.982806 394.770496,950.965612 C392.552235,944.287483
               329.33178,765.091013 205.109131,413.376204 C202.890869,404.472031 204,398.906923 208.436523,396.68088
                C215.091308,393.341816 221.746093,393.341816 228.400877,400.019945 C232.837401,404.472031
                293.839594,472.366346 411.407458,603.702889 Z"
              id="Path-3-Copy"
            />
          </g>
        </g>
      </g>
    </svg>
    <vue-snotify />
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseSpinner from '../components/BaseSpinner.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseFormField from '../components/BaseFormField.vue';
import BaseInput from '../components/BaseInput.vue';
import Box from '../components/Box.vue';

export default {
    name: 'Login',
    components: {
        Box, BaseInput, BaseFormField, BaseButton, BaseSpinner,
    },
    props: {
        nextUrl: { type: String, default: '' },
    },
    data() {
        return {
            loading: false,
            isLoading: true,
            form: {
                username: '',
                password: '',
            },
        };
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
        }),
    },
    methods: {
        ...mapActions({
            login: 'auth/login',
        }),
        async onLogin() {
            try {
                this.loading = true;

                await this.login(this.form);
                setTimeout(() => {
                    this.loading = false;

                    if (this.$route.query.url) {
                        this.$router.push({ path: this.$route.query.url });
                    } else {
                        this.$router.push({ name: 'preparations' });
                    }
                }, 600);
            } catch (error) {
                this.loading = false;
            }
        },
    },
    async created() {
        if (this.isAuthenticated) {
            this.$router.push({ name: 'preparations' });
        }
        this.isLoading = false;
    },
};
</script>

<style lang="scss" scoped>
.jens-enter-active, .jens-leave-active {
  transition: all .3s;
}
.jens-enter, .jens-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.login {
    position: relative;
    background-color: $brand;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &__loader {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__checkmark {
        // height: 50%;
        // width: 50%;
        g { fill: $white; }
        position: absolute;
        // left: 0;
        opacity: 0.15;
        user-select: none;
    }

    &__img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        object-fit: cover;
        object-position: center;
        user-select: none;
    }

    &__form {
        padding: 40px;
        z-index: 1;
        border-radius: 5px;
        width: 350px;
        background-color:$white;
        margin: 0;

        &-inner {
            height: 180px;
        }
    }
}
</style>
